module.exports = __webpack_public_path__ + "img/traditional_icon.b0d2000d.svg";